import { comments } from '@/mocks/comments';

const hotComments = [comments[0], comments[4], comments[5], comments[6], comments[8]];

export default function CommentHighlights() {
  return (
    <section className="bg-background-100 py-14 md:py-20 px-4 md:px-6">
      <div className="mx-auto max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-accent-100 mb-4">
            <i className="ri-chat-quote-line text-accent-600 text-xl"></i>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            吃瓜群众<span className="text-accent-600">热议</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-600">看看大家都在讨论什么爆料</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotComments.slice(0, 3).map((comment) => (
            <div key={comment.id} className="bg-background-50 rounded-xl p-5 flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={comment.avatar} alt={comment.user} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.user}</p>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>
              <div className="relative">
                <i className="ri-double-quotes-l text-2xl text-accent-300 absolute -top-2 -left-1"></i>
                <p className="text-sm text-foreground-700 leading-relaxed pl-5 line-clamp-4">
                  {comment.content}
                </p>
              </div>
              <div className="flex items-center gap-4 text-xs text-foreground-500 mt-auto">
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes > 1000 ? `${(comment.likes / 1000).toFixed(1)}k` : comment.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </div>
          ))}

          <div className="md:col-span-2 lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {hotComments.slice(3, 5).map((comment) => (
              <div key={comment.id} className="bg-background-50 rounded-xl p-5 flex flex-col gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={comment.avatar} alt={comment.user} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{comment.user}</p>
                    <p className="text-xs text-foreground-500">{comment.date}</p>
                  </div>
                </div>
                <div className="relative">
                  <i className="ri-double-quotes-l text-2xl text-accent-300 absolute -top-2 -left-1"></i>
                  <p className="text-sm text-foreground-700 leading-relaxed pl-5 line-clamp-3">
                    {comment.content}
                  </p>
                </div>
                <div className="flex items-center gap-4 text-xs text-foreground-500 mt-auto">
                  <span className="flex items-center gap-1">
                    <i className="ri-thumb-up-line"></i>
                    {comment.likes > 1000 ? `${(comment.likes / 1000).toFixed(1)}k` : comment.likes}
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-chat-1-line"></i>
                    回复
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}